export const NOTIFICATION_CONTAINER_SELECTOR = ".notification-container";